import { useInView } from "react-intersection-observer";
import why from '../assets/images/why.png';

const Why = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px',
  });

  return (
    <div className="h-screen bg-cover overflow-hidden">
      <div className="hidden md:block h-screen">
        <div ref={ref} className="max-w-[800px] h-full w-full mx-auto flex items-center justify-around">
          <img src={why} alt="" className="max-h-240-mobile-touch max-h-600-desktop-pointer"/>
        </div>
      </div>
      <div className="md:hidden flex justify-center items-center h-screen">
        <div ref={ref} className="max-w-[500px] h-full w-full mx-auto flex items-center justify-around">
          <img src={why} alt=""/>
        </div>
      </div>
    </div>
  );
};

export default Why;